import { Triangle } from "@icons";
import * as cn from "classnames";
import * as React from "react";
import { SvgIcon } from "../../SvgIcon";
import "./Paginator.css";

export interface PaginatorData {
    headerData?: string[];
    contentData?: string[][];
}

interface PaginatorProps {
    data: PaginatorData;
    pageCountInList?: number;
    className?: string;
}

interface PaginatorState {
    activePage: number;
}

const chunkSize = 10;

export class Paginator extends React.Component<PaginatorProps, PaginatorState> {
    protected pagesCount: number;
    protected pages = [] as any;
    protected bodyContent: string[][] = [];
    protected headerData: string[];
    protected pageCountInList: number;

    static defaultPageCountInList = 4;

    constructor(props: PaginatorProps) {
        super(props);
        this.state = {
            activePage: 0
        };

        this.bodyContent = props.data.contentData;
        this.pages = this.sliceDataToChunks(props.data.contentData, chunkSize);
        this.pagesCount = this.pages.length;
        this.headerData = props.data.headerData;
        if (this.pages.length < Paginator.defaultPageCountInList) {
            this.pageCountInList = this.pages.length;
        } else {
            this.pageCountInList = props.pageCountInList || Paginator.defaultPageCountInList;
        }
    }

    protected sliceDataToChunks = (arr: string[][], chunkSize: number) => {
        var myArray = [];
        for (var i = 0; i < arr.length; i += chunkSize) {
            myArray.push(arr.slice(i, i + chunkSize));
        }
        return myArray;
    };

    protected nextPage = () => {
        this.setState((prevState: PaginatorState) => ({
            activePage: ++prevState.activePage
        }));
    };

    protected prevPage = () => {
        this.setState((prevState: PaginatorState) => ({
            activePage: --prevState.activePage
        }));
    };

    protected setActivePage = (activePage: number) => this.setState({ activePage });

    protected praparePageList = () => {
        let { activePage } = this.state;
        let pageList: number[] = [];
        const activePageLabel = activePage + 1;
        let countOfPagesToAdd = this.pageCountInList - 1;

        if (activePageLabel + countOfPagesToAdd <= this.pagesCount) {
            if (activePage == 1) {
                --countOfPagesToAdd;
                pageList.push(0);
            }
            for (let i = 0; i <= countOfPagesToAdd; i++) {
                pageList.push(activePage++);
            }
        } else {
            let pagesToFinish = this.pagesCount - activePageLabel;
            let pagesBeforeActive = this.pageCountInList - 1 - pagesToFinish;
            //shift pages before current
            for (; pagesBeforeActive !== 0; pagesBeforeActive--) {
                pageList.push(activePage - pagesBeforeActive);
            }

            pageList.push(activePage);

            //push pages after current
            while (pagesToFinish--) {
                pageList.push(++activePage);
            }
        }
        return pageList;
    };

    render() {
        const { activePage } = this.state;
        const pages = this.pages[activePage];
        const pageLabel = activePage + 1;
        const pageList = this.praparePageList();

        return (
            <div className={cn("Paginator", [this.props.className])}>
                <table className="Paginator__table Paginator__table__header">
                    <thead>
                        <tr>
                            {this.headerData.map((e, i) => {
                                return <th key={i}>{e}</th>;
                            })}
                        </tr>
                        <tr className="Paginator__table header_margin" />
                    </thead>
                    <tbody>
                        {(pages || []).map((row: string[], index: number) => {
                            return (
                                <tr key={`row-${index}`}>
                                    {row.map((headerCellData: string | any, dataIndex) => {
                                        let CustomComponent = typeof headerCellData == "object" ? headerCellData : null;
                                        return CustomComponent ? (
                                            <td key={`data-${dataIndex}`}>{CustomComponent}</td>
                                        ) : (
                                            <td key={`data-${dataIndex}`}>{headerCellData}</td>
                                        );
                                    })}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
                {this.pages.length > 1 && (
                    <div className="Paginator__controls wrapper">
                        <button
                            onClick={() => this.setState({ activePage: 0 })}
                            className={cn("Paginator__controls page-first")}
                        >
                            First
                        </button>
                        <button
                            onClick={this.prevPage}
                            disabled={pageLabel == 1}
                            className="Paginator__controls page-prev"
                        >
                            <SvgIcon svg={Triangle} />
                        </button>

                        <div className="Paginator__controls page-list">
                            {pageList.map(pageNum => (
                                <span
                                    onClick={() => this.setActivePage(pageNum)}
                                    className={cn("page-list page-label", { active: pageNum == activePage })}
                                    key={pageNum}
                                >
                                    {pageNum + 1}
                                </span>
                            ))}
                        </div>

                        <button
                            onClick={this.nextPage}
                            disabled={pageLabel + 1 > this.pagesCount}
                            className="Paginator__controls page-next"
                        >
                            <SvgIcon svg={Triangle} />
                        </button>
                        <button
                            className={cn("Paginator__controls page-last")}
                            onClick={() => this.setActivePage(this.pagesCount - 1)}
                        >
                            Last
                        </button>
                    </div>
                )}
            </div>
        );
    }
}
